import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { align: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "pb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                rounded: "pill",
                color: "primary",
                variant: "flat",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUserRow(_ctx.currentGroup))),
                disabled: !_ctx.filteredUsers.length
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Add user")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "pb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                rounded: "pill",
                color: "primary",
                variant: "flat",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addAllUsers(_ctx.currentGroup))),
                disabled: !_ctx.filteredUsers.length
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Add all users")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "pb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                rounded: "pill",
                color: "primary",
                variant: "flat",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeAllUsers(_ctx.currentGroup)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Remove all users")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "pt-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentGroup?.users, (user) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: user.email,
                      style: {"background-color":"rgba(0,0,0,0.05)"},
                      rounded: "",
                      class: "my-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "flex-nowrap",
                          justify: "space-between",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "11" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.fullName(user.first_name, user.last_name)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(user.email), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { cols: "1" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_action, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_dialog, { attach: true }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps(props, {
                                          icon: "",
                                          variant: "flat",
                                          color: "transparent",
                                          size: "32"
                                        }), {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              icon: "mdi-delete",
                                              color: "primary",
                                              size: "24"
                                            })
                                          ]),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      default: _withCtx(({ isActive }) => [
                                        _createVNode(_component_v_card, { "max-width": "460" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Remove user from group")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_card_text, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Are you sure you want to remove this application from this group? This group must have no assigned users in any account in order to be deleted. ")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_card_actions, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_spacer),
                                                _createVNode(_component_v_btn, {
                                                  onClick: ($event: any) => (isActive.value = false)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Cancel ")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_v_btn, {
                                                  color: "primary",
                                                  onClick: ($event: any) => {isActive.value = false; _ctx.removeUserFromGroup(user)}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Remove ")
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersToAdd, (user) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: user.email,
                      style: {"background-color":"rgba(0,0,0,0.05)"},
                      rounded: "",
                      class: "my-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          justify: "space-between",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "11" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.fullName(user.first_name, user.last_name)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(user.email), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { cols: "1" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_action, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      variant: "flat",
                                      color: "transparent",
                                      size: "32",
                                      onClick: ($event: any) => (_ctx.removeNewUser(user))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          icon: "mdi-delete",
                                          color: "primary",
                                          size: "24"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newUsers, (user) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      class: "mb-1 px-0 pt-0",
                      key: user.email
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_combobox, {
                          class: "app-combobox",
                          clearable: "",
                          items: _ctx.filteredUsers,
                          "custom-filter": _ctx.filterUsers,
                          "item-title": item => _ctx.fullName(item.first_name, item.last_name),
                          "hide-details": "",
                          density: "comfortable",
                          placeholder: "Search users",
                          "return-object": "",
                          "menu-props": { maxWidth: 452 },
                          modelValue: _ctx.newUser,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUser) = $event)),
                          onBlur: _ctx.clearIfNoSelection
                        }, {
                          selection: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_1, [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.fullName(item.raw.first_name, item.raw.last_name)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.raw.email), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          item: _withCtx(({ props, item }) => [
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_component_v_list_item, _mergeProps(props, {
                                onClick: ($event: any) => {_ctx.newUser = item.raw; _ctx.addUserToGroup()}
                              }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.raw.email), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1040, ["onClick"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["items", "custom-filter", "item-title", "modelValue", "onBlur"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}